import React from 'react';
import styled from 'styled-components';
import {
  primaryColor, secondaryFont, maxWidth, retina, wMLight,
} from 'Utils/utilsStyle';
import ArrowDownIcon from '../assets/svgIcons/ArrowDownIcon';
// import ArrowDownIcon from '../assets/svgIcons/ArrowDownIcon';

type Props = {
  onClick: () => void;
  text?: string;
};

const defaultProps = {
  text: '',
};

const Span = styled.div`
 color: ${primaryColor};
 font-weight: ${wMLight};
 font-family: ${secondaryFont};
 font-size: 14px;
 line-height: 25px;
 text-align: center;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 width: 100%;
 cursor: pointer;
 svg {
  margin-left: 10px;
  transform: rotate(180deg);
  @media all and (max-width: ${maxWidth}) , ${retina} {
    margin-left: 5px;
    width:12px;
  }
 }
`;

const ShowLessData = function ShowLessData(props: Props) {
  const { onClick, text } = props;
  return (
    <Span onClick={onClick} className="arrow-down-icon-wrapper">
      Show less
      {text && <ArrowDownIcon />}
    </Span>
  );
};

ShowLessData.defaultProps = defaultProps;
export default ShowLessData;
